import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { EqualHeightElement } from "react-equal-height";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardArt from "./CardArt";
import { tunein } from "lib/player_util";
const PlayCard = ({ image, title, station_id, musicPath, singleCard }) => {
  const outerClick = () => {
    if (!musicPath && station_id) {
      tunein(station_id);
    }
  };
  const innerClick = () => {
    if (musicPath && station_id) {
      tunein(station_id);
    }
  };

  return (
    <div className="card" onClick={outerClick}>
      <div className="play-hover-container">
        <div className="no_jump_wrapper" onClick={innerClick}>
          <CardArt image={image} />

          <div className="play-hover">
            <FontAwesomeIcon icon="play-circle" />
          </div>
        </div>
        {singleCard ? (
          <div className="card-inner">
            <div>
              {musicPath ? (
                <Link to={musicPath} title={`Go to ${title}`}>
                  {title}
                </Link>
              ) : (
                <Fragment>{title}</Fragment>
              )}
            </div>
          </div>
        ) : (
          <EqualHeightElement>
            <div className="card-inner">
              <div>
                {musicPath ? (
                  <Link to={musicPath} title={`Go to ${title}`}>
                    {title}
                  </Link>
                ) : (
                  <Fragment>{title}</Fragment>
                )}
              </div>
            </div>
          </EqualHeightElement>
        )}
      </div>
    </div>
  );
};

export default PlayCard;
